module.exports = __webpack_public_path__ + "img/share_icon.1bb5e71c.svg";